<template>
  <popup-modal ref="popup">
    <button class="leaving-modal" @click="closeModal">
      <img style="width: 16px" :src="closeImg" alt="Close" />
    </button>
    <h2>{{ title }}</h2>
    <p v-html="message"></p>
    <div class="btns">
      <button class="ok-btn" @click="_confirm">{{ okButton }}</button>
      <button class="cancel-btn" @click="_cancel">{{ cancelButton }}</button>
    </div>
  </popup-modal>
</template>

<script>
import PopupModal from "./confirmModal.vue";
export default {
  name: "ConfirmDialogue",
  components: { PopupModal },
  data: () => ({
    closeImg: "/themes/web/assets/images/icon/icon-del-dialog.png",
    // Parameters that change depending on the type of dialogue
    title: undefined,
    message: undefined, // Main text content
    okButton: undefined, // Text for confirm button; leave it empty because we don't know what we're using it for
    cancelButton: "Go Back", // text for cancel button

    // Private variables
    resolvePromise: undefined,
    rejectPromise: undefined,
  }),
  methods: {
    show(opts = {}) {
      this.title = opts.title;
      this.message = opts.message;
      this.okButton = opts.okButton;
      if (opts.cancelButton) {
        this.cancelButton = opts.cancelButton;
      }
      // Once we set our config, we tell the popup modal to open
      this.$refs.popup.open();
      // Return promise so the caller can get results
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },

    _confirm() {
      this.$refs.popup.close();
      this.resolvePromise(true);
    },

    _cancel() {
      this.$refs.popup.close();
      this.resolvePromise(false);
      // Or you can throw an error
      // this.rejectPromise(new Error('User cancelled the dialogue'))
    },
    closeModal() {
      this.$refs.popup.close();
    },
  },
};
</script>

<style scoped>
h2 {
  margin-top: 0;
  font-size: 24px;
  font-weight: 700;
  padding: 4px 48px;
  letter-spacing: 0.48px;
  color: #212529;
}

p {
  padding: 16px;
  color: #212529;
}

.btns {
  padding: 4px 48px;
}

.btns .ok-btn {
  color: var(--squid-black, #191715);
  text-decoration: none;
  cursor: pointer;
  background: var(--Creme-Light, #fff);
  box-shadow: 4px 4px 0px 0px #d2d2d2;
  border: 1px solid var(--Cloud-Dark, #cfcfcf);
  border-radius: 48px;
  padding: 16px 24px;
  font-size: 16px;
  font-weight: 700;
  width: 100%;
  margin-bottom: 10px;
}

.cancel-btn {
  text-decoration: none;
  padding: 16px 24px;
  color: var(--squid-black, #191715);
  border: 1px solid var(--Pistatrio-Dark, #e3e87a);
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
  background: var(--Pistatrio-Light, #f8fe5f);
  box-shadow: 4px 4px 0px 0px #e3e87a, 0px 0px 16px 0px #f8fe5f;
  border-radius: 48px;
  margin-right: 15px;
  font-weight: 700;
  width: 100%;
}

.leaving-modal {
  padding: 7px 10px;
  border-radius: 48px;
  border: 1px solid var(--Cloud-Dark, #cfcfcf);
  background: var(--Creme-Light, #fff);
  box-shadow: 0px 4px 0px 0px #d2d2d2;
  position: absolute;
  right: 1px;
  top: 1px;
  height: 40px;
}

.leaving-modal img {
  max-width: 100%;
}

.popup-modal {
  background: linear-gradient(180deg,
      rgba(56, 23, 112, 0.5) 0%,
      rgba(127, 44, 134, 0.5) 100%) !important;
  backdrop-filter: blur(12px) !important;
}

.popup-modal .window {
  border-radius: 56px !important;
}
</style>
